//! Único lugar donde se obtienen las variables de entorno.
export default function getParamsEnv() {
  const SECURE = process.env.REACT_APP_SECURE === "TRUE";
  const ROOT = SECURE ? process.env.REACT_APP_ROOT : "/";
  const DASHBOARD = SECURE ? process.env.REACT_APP_DASHBOARD : "/*";
  const PROJECTS = SECURE ? process.env.REACT_APP_PROJECTS : "/proyectos";
  const USERS = SECURE ? process.env.REACT_APP_USERS : "/usuarios";
  const ROLES = SECURE ? process.env.REACT_APP_ROLES : "/roles";
  const ACCESS = SECURE ? process.env.REACT_APP_ACCESS : "/accesos";
  const REPORTPROJECTS = SECURE
    ? process.env.REACT_APP_REPORTPROJECTS
    : "/reportes/proyectos";
  const API_URL_BASE = SECURE
    ? process.env.REACT_APP_URL_BASE
    : process.env.REACT_APP_URL_BASE || "/backend/";

  return {
    ROOT,
    DASHBOARD,
    PROJECTS,
    USERS,
    ROLES,
    ACCESS,
    REPORTPROJECTS,
    API_URL_BASE,
  };
}
